// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@fortawesome/fontawesome-free/css/all.css'
import '@babel/polyfill'

import Vue from 'vue'
import './plugins/vuetify'
import Vuex from 'vuex'

import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import AuthService from "@/services/AuthService"
import VueTruncate from 'vue-truncate-filter'

import VueResource from 'vue-resource'
import AmazeSnackbar from '@/components/Widgets/AmazeSnackbar'
import AmazeSquiggle from '@/components/Widgets/AmazeSquiggle'
import AmazeUpload from '@/components/Widgets/AmazeUpload'
import AmazeUserfile from '@/components/Widgets/AmazeUserfile'
import AmazeEditor from '@/components/Widgets/AmazeEditor'
import AmazeUserGroups from '@/components/Widgets/AmazeUserGroups'

import VueClip from 'vue-clip'
import VueMoment from 'vue-moment'
import moment from 'moment'
import Scrollactive from 'vue-scrollactive'
import VueYouTubeEmbed from 'vue-youtube-embed'

import GroupService from "@/services/GroupService"
import TrainingModuleService from "@/services/TrainingModuleService"

// import FileManager from "amaze-file-manager-ui"
import FileManager from "@/plugins/amaze-file-manager-ui"

// convert a date to local time
Vue.filter('localTime', function (value) {
  if (value) {
    let stillUtc = moment.utc(value).toDate();
    return moment(stillUtc).local().fromNow(true);
  }
});

Vue.use(VueResource)
Vue.use(Vuex)
Vue.component('amaze-snackbar', AmazeSnackbar)
Vue.component('amaze-squiggle', AmazeSquiggle)
Vue.component('amaze-upload', AmazeUpload)
Vue.component('amaze-userfile', AmazeUserfile)
Vue.component('amaze-user-groups', AmazeUserGroups)
Vue.component('amaze-editor', AmazeEditor)
Vue.use(VueClip)
Vue.use(VueMoment, {
  moment
})
Vue.use(Scrollactive);
// Vue.use(underscore);
Vue.use(VueTruncate)
Vue.use(VueYouTubeEmbed, {
  global: false
});

Vue.config.productionTip = false
Vue.http.options.root = process.env.VUE_APP_API_BASE
Vue.router = router

Vue.use(VueAnalytics, {
  id: 'UA-124594667-2',
  debug: {
    autoTracking: {
      exception: true
    },
    enabled: false,
    sendHitTask: true
  },
  router
})

const store = new Vuex.Store({
  state: {
    snackbar: false,
    message: 'This is the default text.',
    groups: [],
    modules: [],
    notifications: [],
    loading: false,
    dsec_event_tracker: false
  },
  mutations: {
    updateMessage(state, payload) {
      state.message = payload.message
      state.snackbar = payload.snackbar
    },
    loading(state, payload) {
      if (payload.loading) {
        state.loading = true;
      } else {
        state.loading = false;
      }
    },
    updateGroups(state) {
      GroupService.getMyGroups()
        .then(
          response => {
            // get body data
            state.groups = response;

            // Check to see if you are in element 5 group or an
            // uber admin to have access to DSEC Event Links.
            state.dsec_event_tracker = (response.filter((group) => {
              return group.extra_attributes && group.extra_attributes.dsec === true;
            }).length > 0);
          },
          response => {
            console.log("[error] GroupsService:getMyGroups");
          }
        )
    },
    updateModules(state) {
      TrainingModuleService.getMyModules()
        .then(
          response => {
            // get body data
            state.modules = response;
          },
          response => {
            console.log("[error] TrainingModuleService:getMyModules");
          }
        )
    },
    updateNotifications(state) {
      Vue.http.get("notifications").then(
        response => {
          state.notifications = response.body.data;
        },
        response => {
          console.log("Error getting notifications.");
        }
      );
    }
  }
})

Vue.use(FileManager, {
  store
});

// setup our Auth route
if (process.env.NODE_ENV !== 'ci') {
  AuthService.initAuth(store)
}

// There is an issue with our version of Vuetify where the calendar component
// throws this warning and this catches it and blocks it. Annoying.
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});

// This pleases the linter.
(function () {})(app);
